import { makeStyles } from "@material-ui/core";

const makeClasses = makeStyles((theme) => ({
  container: {},
}));

export default makeClasses;
